import apiCall, { makeUrl } from "../../utils/apiCall";
import { put } from "redux-saga/effects";

export function* getCategories() {
  yield put({ type: "SET_LOADING", key: "categories", loading: true });
  const getCategoriesCall = yield apiCall();
  const result = yield getCategoriesCall.get(makeUrl("/category"));
  yield put({ type: "SAVE_CATEGORIES", categories: result.data });
  yield put({ type: "SET_LOADING", key: "categories", loading: false });
}

export function* getMyFeedCategories() {
  yield put({ type: "SET_LOADING", key: "get-my-feed-categories", loading: true });
  try {
    const getMyFeedCategoriesCall = yield apiCall();
    const result = yield getMyFeedCategoriesCall.get(makeUrl("/my-feed-categories"));
    yield put({ type: "SAVE_MY_FEED_CATEGORIES", feedCategories: result.data.feedCategories });
  } finally {
    yield put({ type: "SET_LOADING", key: "get-my-feed-categories", loading: false });
  }
}
